define("calendar/controllers/media", ["exports", "@ember/controller", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency-decorators", "ember-concurrency-ts", "tracked-built-ins", "later/utils/constants", "later/utils/focus"], function (_exports, _controller, _object, _service, _tracking, _emberConcurrencyDecorators, _emberConcurrencyTs, _trackedBuiltIns, _constants, _focus) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;

  0; //eaimeta@70e063a35619d71f0,"@ember/controller",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency-decorators",0,"ember-concurrency-ts",0,"tracked-built-ins",0,"later/utils/constants",0,"later/utils/focus"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  let MediaController = (_dec = (0, _object.computed)('model.{processing,isVideo,isGif,isImage,failed}', 'currentAccount.stopTheWorld', 'selectedSocialProfiles.profiles'), _dec2 = (0, _object.computed)('currentGroup.contributor', 'mediaItem.approved'), _dec3 = (0, _object.computed)('currentGroup.contributor', 'mediaItem.approved'), _dec4 = (0, _object.computed)('model.group.labels.[]'), _dec5 = (0, _object.computed)('model.dirtyType'), _dec6 = (0, _object.computed)('model.labels.[]'), _dec7 = (0, _object.computed)('secondaryModal.isModalOpen'), _dec8 = (0, _object.computed)('model.{processing,isVideo,isImage}', 'currentAccount.stopTheWorld', 'profiles'), (_class = class MediaController extends _controller.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "auth", _descriptor, this);

      _initializerDefineProperty(this, "intl", _descriptor2, this);

      _initializerDefineProperty(this, "mediaLabels", _descriptor3, this);

      _initializerDefineProperty(this, "errors", _descriptor4, this);

      _initializerDefineProperty(this, "secondaryModal", _descriptor5, this);

      _initializerDefineProperty(this, "segment", _descriptor6, this);

      _initializerDefineProperty(this, "selectedSocialProfiles", _descriptor7, this);

      _initializerDefineProperty(this, "dialogManager", _descriptor8, this);

      _initializerDefineProperty(this, "savedCaptionToEdit", _descriptor9, this);

      _initializerDefineProperty(this, "editingCaption", _descriptor10, this);

      _initializerDefineProperty(this, "uniqueId", _descriptor11, this);

      _initializerDefineProperty(this, "comments", _descriptor12, this);

      _initializerDefineProperty(this, "location", _descriptor13, this);

      _initializerDefineProperty(this, "showComments", _descriptor14, this);

      _initializerDefineProperty(this, "viewDetail", _descriptor15, this);
    }

    get canCreatePost() {
      if (!this.socialProfile) {
        return false;
      } else if (this.showUpgradeButton) {
        return false;
      } else if (this.model.processing && !this.model.isVideo) {
        return false;
      } else if (this.model.failed) {
        return false;
      } else if (this.model.isVideo && !this.socialProfile.canPostVideo) {
        return false;
      } else if (this.model.isGif && !this.socialProfile.canPostGif) {
        return false;
      } else if (this.socialProfile.isTiktok && this.model.isImage) {
        return false;
      } else if (this.currentAccount.stopTheWorld) {
        return false;
      }

      return true;
    }

    get canDestroyMedia() {
      return !(this.currentGroup.contributor && this.mediaItem.approved);
    }

    get canEditLabel() {
      return !this.currentGroup.contributor;
    }

    get createPostText() {
      var _this$socialProfile;

      const isPinterest = (_this$socialProfile = this.socialProfile) === null || _this$socialProfile === void 0 ? void 0 : _this$socialProfile.get('isPinterest');
      return this.intl.t(isPinterest ? 'calendar.modal.pinterest.create_post' : 'calendar.modal.create_post');
    }

    get currentAccount() {
      return this.auth.currentAccount;
    }

    get currentGroup() {
      return this.auth.currentGroup;
    }

    get groupLabels() {
      return this.model.group.labels;
    }

    get hasDirtyAttributes() {
      return this.model.dirtyType === 'updated';
    }

    get hasLabels() {
      return this.model.labels.length > 0;
    }

    get hasSecondary() {
      return this.secondaryModal.isModalOpen();
    }

    get linkingSocialProfile() {
      return this.socialProfile || this.auth.currentSocialProfile;
    }

    get mediaItem() {
      return this.model;
    }

    get profiles() {
      return this.selectedSocialProfiles.profiles;
    }

    get rejectCreatePostReason() {
      var _this$socialProfile2;

      if (!((_this$socialProfile2 = this.socialProfile) !== null && _this$socialProfile2 !== void 0 && _this$socialProfile2.hasPostsLeft)) {
        return this.intl.t('media_items.update.max_posts');
      } else if (this.model.processing) {
        return this.intl.t('media_items.update.processing_post');
      } else if (this.model.failed) {
        return this.intl.t('media_items.update.failed_media');
      } else if (this.model.isVideo && !this.socialProfile.canPostVideo) {
        if (this.socialProfile.isLinkedin) {
          return this.intl.t('alerts.linkedin.errors.video_not_supported_message');
        }

        return this.intl.t('posts.modal.unsupported_video_platform.pinterest_message');
      } else if (this.model.isGif && !this.socialProfile.canPostGif) {
        return this.intl.t('posts.modal.unsupported_gif_platform', {
          platform: this.socialProfile.accountType
        });
      } else if (this.socialProfile.isTiktok && this.model.isImage) {
        return this.intl.t('alerts.tiktok.errors.invalid_media.message');
      } else if (this.currentAccount.stopTheWorld) {
        return this.intl.t('posts.modal.stop_the_world');
      }

      return null;
    }

    get showUpgradeButton() {
      var _this$socialProfile3;

      return !((_this$socialProfile3 = this.socialProfile) !== null && _this$socialProfile3 !== void 0 && _this$socialProfile3.hasPostsLeft);
    }

    get socialProfile() {
      return this.selectedSocialProfiles.firstProfile;
    }

    addNewLabel(label) {
      let labelList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      let createdFromLabelMedia = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      (0, _emberConcurrencyTs.taskFor)(this._addNewLabel).perform(label, labelList, createdFromLabelMedia);
    }

    addSuggestedHashtags(tags) {
      this.set(this.model.defaultCaption, "".concat(this.model.defaultCaption, " ").concat(tags));
    }

    cancelEditingCaption() {
      this.model.rollbackAttributes();
      this.editingCaption = false;
    }

    deleteLabel(label) {
      this.mediaLabels.deleteLabel(label);
    }

    editCaption() {
      this.editingCaption = true;
      (0, _focus.default)('#textareaMediaNote');
    }

    savedCaptionSegmentEvent(eventName, savedCaptionTitle) {
      this.segment.track(eventName, {
        group_id: this.currentGroup.id,
        location: 'media_item',
        saved_caption_title: savedCaptionTitle
      });
    }

    saveModelIfDirty() {
      if (this.hasDirtyAttributes) {
        // gets called when user hits "Create Post" and media item is in a dirty state --G
        this.model.save();
      }
    }

    toggleCaptionTemplate() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants.SECONDARY_MODAL_TYPES.SAVED_CAPTIONS);
    }

    toggleSecondary(type, location) {
      this.secondaryModal.toggleModal(this.uniqueId, type, location);
    }

    toggleSmartHashtags() {
      this.secondaryModal.toggleModal(this.uniqueId, _constants.SECONDARY_MODAL_TYPES.SMART_HASHTAGS);
    }

    toggleStarred() {
      if (this.mediaItem.isStarred) {
        this.send('removeStarred', this.mediaItem);
      } else {
        this.send('addStarred', this.mediaItem);
      }
    }

    updateMediaItem() {
      this.mediaItem.save().then(() => {
        this.send('closeModal');
      }).catch(adapterError => {
        this.errors.handleAdapter(adapterError, this.mediaItem);
      });
    }

    *_addNewLabel(label, labelList, createdFromLabelMedia) {
      try {
        yield this.mediaLabels.addNewLabel.perform(label, labelList, createdFromLabelMedia);
        this.mediaItem.save();
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError, this.mediaItem);
      }
    }

    *_confirmMediaChanges() {
      const didConfirm = yield this.dialogManager.confirmation(this.intl.t('media_items.update.close_save'));

      if (!didConfirm) {
        return;
      }

      try {
        this.model.save();
        this.send('closeModal');
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError);
      }
    }

    *_confirmCaptionChanges() {
      var _this$savedCaptionToE;

      const didConfirm = yield this.dialogManager.confirm(this.intl.t('media_items.update.close_save'));

      if (!didConfirm) {
        return;
      }

      const isNewSavedCaption = (_this$savedCaptionToE = this.savedCaptionToEdit) === null || _this$savedCaptionToE === void 0 ? void 0 : _this$savedCaptionToE.get('isNew');

      try {
        var _this$savedCaptionToE2;

        (_this$savedCaptionToE2 = this.savedCaptionToEdit) === null || _this$savedCaptionToE2 === void 0 ? void 0 : _this$savedCaptionToE2.save();
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError);
      }

      if (isNewSavedCaption) {
        var _this$savedCaptionToE3;

        this.send('savedCaptionSegmentEvent', 'saved-new-caption', (_this$savedCaptionToE3 = this.savedCaptionToEdit) === null || _this$savedCaptionToE3 === void 0 ? void 0 : _this$savedCaptionToE3.title);
      }

      this.savedCaptionToEdit = null;
      this.send('closeModal');
    }

    *_rollbackModelAndClose() {
      try {
        yield this.model.rollbackAttributes();
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError);
      }

      this.send('closeModal');
    }

    *canClose() {
      var _this$savedCaptionToE4, _this$savedCaptionToE5;

      if (this.hasDirtyAttributes) {
        yield (0, _emberConcurrencyTs.taskFor)(this._confirmMediaChanges).perform();
      } else if ((_this$savedCaptionToE4 = this.savedCaptionToEdit) !== null && _this$savedCaptionToE4 !== void 0 && _this$savedCaptionToE4.isNew || (_this$savedCaptionToE5 = this.savedCaptionToEdit) !== null && _this$savedCaptionToE5 !== void 0 && _this$savedCaptionToE5.hasDirtyAttributes) {
        yield (0, _emberConcurrencyTs.taskFor)(this._confirmCaptionChanges).perform();
      } else {
        yield (0, _emberConcurrencyTs.taskFor)(this._rollbackModelAndClose).perform();
      }
    }

    *rollbackSavedCaption() {
      try {
        var _this$savedCaptionToE6, _this$savedCaptionToE7;

        if ((_this$savedCaptionToE6 = this.savedCaptionToEdit) !== null && _this$savedCaptionToE6 !== void 0 && _this$savedCaptionToE6.isNew) {
          yield this.savedCaptionToEdit.deleteRecord();
        } else if ((_this$savedCaptionToE7 = this.savedCaptionToEdit) !== null && _this$savedCaptionToE7 !== void 0 && _this$savedCaptionToE7.hasDirtyAttributes) {
          yield this.savedCaptionToEdit.rollbackAttributes();
        }

        this.set('savedCaptionToEdit', null);
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError);
      }
    }

    *saveEditedCaption() {
      try {
        yield this.model.save();
        this.segment.track('updated-media-notes', {
          group_id: this.currentGroup.id,
          media_id: this.model.id,
          media_url: this.model.isVideo ? this.model.videoUrl : this.model.imageUrl,
          notes: this.model.defaultCaption,
          location: this.location ? this.location : ''
        });
      } catch (adapterError) {
        this.errors.handleAdapter(adapterError, this.model);
        this.model.rollbackAttributes();
      }

      this.editingCaption = false;
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "mediaLabels", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "selectedSocialProfiles", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "dialogManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "savedCaptionToEdit", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "editingCaption", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "uniqueId", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "comments", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new _trackedBuiltIns.TrackedArray([]);
    }
  }), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "location", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  }), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "showComments", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  }), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "viewDetail", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "canCreatePost", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "canCreatePost"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canDestroyMedia", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "canDestroyMedia"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canEditLabel", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "canEditLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "groupLabels", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "groupLabels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasDirtyAttributes", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "hasDirtyAttributes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasLabels", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "hasLabels"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasSecondary", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "hasSecondary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rejectCreatePostReason", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "rejectCreatePostReason"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addNewLabel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addNewLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addSuggestedHashtags", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addSuggestedHashtags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancelEditingCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelEditingCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteLabel", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "editCaption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "editCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "savedCaptionSegmentEvent", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "savedCaptionSegmentEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveModelIfDirty", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "saveModelIfDirty"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleCaptionTemplate", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCaptionTemplate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSecondary", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSecondary"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleSmartHashtags", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleSmartHashtags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleStarred", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleStarred"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateMediaItem", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateMediaItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_addNewLabel", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "_addNewLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_confirmMediaChanges", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "_confirmMediaChanges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_confirmCaptionChanges", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "_confirmCaptionChanges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_rollbackModelAndClose", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "_rollbackModelAndClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canClose", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "canClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "rollbackSavedCaption", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "rollbackSavedCaption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveEditedCaption", [_emberConcurrencyDecorators.task], Object.getOwnPropertyDescriptor(_class.prototype, "saveEditedCaption"), _class.prototype)), _class));
  _exports.default = MediaController;
});